import {z} from 'zod'

export const defaultValues = {
  tierId: '',
  activities: [
    {
      activityID: '',
      multiplier: 0,
    },
  ],
  content: {
    'es_MX': {
      tierName: '',
      displayDescription: '',
      imageTierIcon: '',
      bannerHeader: '',
      bannerDescription: '',
      bannerImage: '',
      detailsDescription: '',
      detailsTermsAndConditions: '',
      detailsImage: '',
    },
    'en_US': {
      tierName: '',
      displayDescription: '',
      imageTierIcon: '',
      bannerHeader: '',
      bannerDescription: '',
      bannerImage: '',
      detailsDescription: '',
      detailsTermsAndConditions: '',
      detailsImage: '',
    },
  },
}

const displayItemSchema = z.object({
  tierName: z.string().nonempty("Tier Name is required"),
  displayDescription: z.string().max(30).optional(),
  imageTierIcon: z.number().positive(),
  bannerHeader: z.string().nonempty("Banner Header is required"),
  bannerDescription: z.string().optional(),
  bannerImage: z.number().positive(),
  detailsDescription: z.string().nonempty(),
  detailsTermsAndConditions: z.string().optional(),
  detailsImage: z.number().positive(),
})

export const activityItemSchema = z.object({
  activityID: z.string().nonempty(),
  multiplier: z.number().positive(),
})

export const createTierSchema = z.object({
  tierId: z.string().nonempty(),
  activities: z.array(activityItemSchema).min(1),
  content: z.object({
    'en_US': displayItemSchema,
    'es_MX': displayItemSchema,
  }),
})
